interface TypeLegislation {
  key: string;
  name: string;
}

const types_legislation = [
  { key: 'ApplicableLegislation', name: 'Legislația aplicabilă' },
  { key: 'CourtRegulation', name: 'Regulamentul Curții de Conturi' },
  { key: 'AdministrativeCode', name: 'Codul administrativ' },
  { key: 'AcquisitionLegislation', name: 'Legislație achiziții' },
  {
    key: 'AcquisitionGuide',
    name: 'Ghidurile de audit ale Curții de Conturi'
  },
  {
    key: 'InternalDocument',
    name: 'Documente interne'
  }
];

const types_legislation_institution = [
  { key: 'ApplicableLegislation', name: 'Legislația aplicabilă' },
  { key: 'AcquisitionLegislation', name: 'Legislație achiziții' },
  {
    key: 'InternalDocument',
    name: 'Documente interne'
  }
];

interface EntryLegislation {
  id: number;
  name: string;
  type: string;
}

export { types_legislation, types_legislation_institution };
export type { TypeLegislation, EntryLegislation };
